/* global width:true */
/* eslint no-undef: "error" */

import React from "react";
import { LoadMoreCollectionStories, Collection } from "@quintype/components";
import { object, func, array, bool } from "prop-types";
import get from "lodash/get";

import { getCollectionTemplate } from "../../get-collection-template";
import Headline from "../../atoms/headline";
import CardImageType1 from "../../molecules/card-image-type-1";
import CardImageType9 from "../../molecules/card-image-type-9";
import CardImageType10 from "../../molecules/card-image-type-10";
import ReadMore from "../../atoms/read-more";
import DfpAd from "../../dfp-ad";

import "./section.m.css";
import SideBar from "./sidebar";
import {Helmet} from "react-helmet";

class SectionPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      width: null
    };
  }
  isWidthPresent = () => {
    this.setState({ width });
  };

  componentDidMount() {
    this.isWidthPresent();
  }

  render() {
    const { data } = this.props;
    const storiesFromCollection = get(data, ["collection", "items"], []).filter(items => items.type === "story");
    const collectionItems = get(data, ["collection", "items"], []).filter(items => items.type === "collection");
    const collectionOfCollection = {
      items: collectionItems
    };
    const topTwoStories = storiesFromCollection && storiesFromCollection.length && storiesFromCollection.slice(0, 2);
    const renderTopTwoStoriesDom = topTwoStories
      ? topTwoStories.map((item, index) => <CardImageType1 story={item.story} key={index} />)
      : "No Stories Found";

    const sectionMeta = () => (
      <div styleName="section-header">
        {data.collection.name && <Headline text={data.collection.name} headerType={12} headerLevel={1} />}
        {data.collection.summary && <p styleName="collection-summary">{data.collection.summary}</p>}
      </div>
    );
    const storiesDom = stories => {
      return stories.slice(2, stories.length).map((item, index) => {
        const storyObj = item.story || item;

        return (
          <React.Fragment key={index}>
            <Helmet>
              <meta name="atdlayout" content="section"/>
            </Helmet>
            <div styleName="set-1-story">
              {index % 3 === 0 ? <CardImageType9 story={storyObj} /> : <CardImageType10 story={storyObj} />}
            </div>
            {index + 1 === 8 && (
              <div styleName="ad">
                <DfpAd adtype="leaderboard_2_728x90" />
              </div>
            )}
            {(index + 1) % 4 === 0 &&
              index + 1 >= 12 && (
                <div styleName="ad">
                  <DfpAd adtype="leaderboard_2_728x90" />
                </div>
              )}
          </React.Fragment>
        );
      });
    };

    const storiesTemplate = ({ onLoadMore, stories, noMoreStories }) => {
      return (
        <div styleName="bottom-stories">
          {storiesDom(stories)}
          {storiesFromCollection.length < data.totalCount && <ReadMore onClick={onLoadMore} />}
        </div>
      );
    };
    const trendingCollection = get(data, ["trendingCollection", "collection"], {});
    const webSpecialCollection = get(data, ["webSpecialCollection", "collection"], {});
    const opinionsCollection = get(data, ["opinionsCollection", "collection"], {});
    const horoscopeCollection = get(data, ["horoscopeCollection", "collection"], {});
    const viralCollection = get(data, ["viralCollection", "collection"], {});

    return (
      <div styleName="wrapper">
        {collectionItems.length >= 1 ? (
          // <LazyCollection
          //   collection={collectionOfCollection}
          //   collectionTemplates={getCollectionTemplate}
          //   lazyAfter={2}
          // />
          <Collection collection={collectionOfCollection} collectionTemplates={getCollectionTemplate} />
        ) : (
          <div>
            {sectionMeta()}
            <div styleName="top-stories-with-ad">
              <div styleName="top-stories">{renderTopTwoStoriesDom}</div>
              <div style={{backgroundColor:"gainsboro",height:"max-content",padding:"20px"}}>
                Visit 10Cric and <a href="https://www.10cric.com/cricket/" style={{color:"blue"}} target = "_blank" >
                bet on cricket matches
                </a> directly on our mobile phone.
                <hr></hr>
                <a href="https://www.sevenjackpots.com/casino/" style={{color:"blue"}} target = "_blank" >
                Online gambling in India at 7Jackpots
                </a>, Indias most trusted website for real money entertainment.
              </div>

              {/* <DfpAd adtype="rectangle_1_300x250" /> */}
            </div>
            <div styleName="bottom-stories-with-sidebar">
              <LoadMoreCollectionStories
                template={storiesTemplate}
                data={{ stories: storiesFromCollection }}
                collectionSlug={data.collection.slug}
                numStoriesToLoad={4}
                params={{ "item-type": "story" }}
              />
              <div styleName="sidebar">
                <SideBar
                  currentSection={data.collection.slug}
                  trendingCollection={trendingCollection}
                  webSpecialCollection={webSpecialCollection}
                  opinionsCollection={opinionsCollection}
                  horoscopeCollection={horoscopeCollection}
                  viralCollection={viralCollection}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

SectionPage.propTypes = {
  data: object,
  onLoadMore: func,
  stories: array,
  noMoreStories: bool
};

export { SectionPage };
